var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"child",attrs:{"data-id":item.id}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }